import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import _isEmpty from 'lodash/isEmpty';
import * as styles from './SizeStyleSelector.css';

const cx = classNames.bind(styles);
export class SizeStyleSelector extends PureComponent {
    constructor() {
        super();
        this.onSizeAndSelectChange = this.onSizeAndSelectChange.bind(this);
        this.renderSizeAndSelectOptions = this.renderSizeAndSelectOptions.bind(this);
    }

    onSizeAndSelectChange(event) {
        const { onStyleChange, selectedNavigationIndex } = this.props;
        const { value } = event.target;
        onStyleChange(value, selectedNavigationIndex);
    }

    renderSizeAndSelectOptions() {
        const { navigations, navigationIndex } = this.props;
        const dropdownOptions = [];
        const defaultSelectedValue = _get(navigations[navigationIndex], 'navItem', '');
        !_isEmpty(navigations) &&
            navigations.map((dataItem, index) =>
                defaultSelectedValue.trim() === dataItem.navItem.trim()
                    ? dropdownOptions.push(
                          <option
                              data-automation-id={`sizeselector-navitem-selected-${index}`}
                              defaultValue={dataItem.navItem}
                              key={dataItem.navItem}
                              selected
                          >
                              {dataItem.navItem}
                          </option>
                      )
                    : dropdownOptions.push(
                          <option
                              data-automation-id={`sizeselector-navitem-${index}`}
                              value={dataItem.navItem}
                              key={dataItem.navItem}
                          >
                              {dataItem.navItem}
                          </option>
                      )
            );
        return dropdownOptions;
    }

    render() {
        const { customBlockClass, customClass } = this.props;
        return (
            <div className={cx('sizeSelectBlock', customBlockClass)}>
                <select
                    data-automation-id="select-box-block"
                    onChange={this.onSizeAndSelectChange}
                    className={cx('sizeSelect', customClass)}
                >
                    {this.renderSizeAndSelectOptions()}
                </select>
            </div>
        );
    }
}

SizeStyleSelector.defaultProps = {
    customBlockClass: '',
    customClass: '',
    navigations: [],
    navigationIndex: 0,
    onStyleChange: _noop,
    selectedNavigationIndex: 0,
};

SizeStyleSelector.propTypes = {
    customBlockClass: PropTypes.string,
    customClass: PropTypes.string,
    navigations: PropTypes.array,
    navigationIndex: PropTypes.number,
    selectedNavigationIndex: PropTypes.number,
    onStyleChange: PropTypes.func,
};

export default SizeStyleSelector;
